/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfCommerceSynchronizationResultDto } from "../models/AjaxResponseOfCommerceSynchronizationResultDto";
import type { AjaxResponseOfListOfCommerceProductDefinitionDto } from "../models/AjaxResponseOfListOfCommerceProductDefinitionDto";
import type { AjaxResponseOfListOfCommerceWorkspaceSubscriptionDto } from "../models/AjaxResponseOfListOfCommerceWorkspaceSubscriptionDto";
import type { AjaxResponseOfListOfProductPlanDto } from "../models/AjaxResponseOfListOfProductPlanDto";
import type { AjaxResponseOfPagedResultDtoOfCommerceEnrollmentMonitorDto } from "../models/AjaxResponseOfPagedResultDtoOfCommerceEnrollmentMonitorDto";
import type { AjaxResponseOfProductPlanChangePreview } from "../models/AjaxResponseOfProductPlanChangePreview";
import type { AjaxResponseOfProductPlanChangeResult } from "../models/AjaxResponseOfProductPlanChangeResult";
import type { AjaxResponseOfProductPlanDto } from "../models/AjaxResponseOfProductPlanDto";
import type { AjaxResponseOfProductSubscriptionDto } from "../models/AjaxResponseOfProductSubscriptionDto";
import type { AssignCommerceProductPlanInput } from "../models/AssignCommerceProductPlanInput";
import type { ChangeWorkspaceCommerceProductPlanInput } from "../models/ChangeWorkspaceCommerceProductPlanInput";
import type { CommerceEnrollmentInput } from "../models/CommerceEnrollmentInput";
import type { CreateOrUpdateProductPlanInput } from "../models/CreateOrUpdateProductPlanInput";
import type { ExtendCommerceTrialInput } from "../models/ExtendCommerceTrialInput";
import type { PreviewWorkspaceProductPlanInput } from "../models/PreviewWorkspaceProductPlanInput";
import type { SetProductPlanActiveInput } from "../models/SetProductPlanActiveInput";
import type { SynchronizeCommerceEntitlementsInput } from "../models/SynchronizeCommerceEntitlementsInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
import type { AdjustProductUsageInput } from "../models/AdjustProductUsageInput";
import type { AjaxResponseOfAdjustedProductUsage } from "../models/AjaxResponseOfAdjustedProductUsage";
export class CommerceAdminAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  public adjustProductUsage({
    requestBody,
  }: {
    requestBody: AdjustProductUsageInput;
  }): CancelablePromise<AjaxResponseOfAdjustedProductUsage> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/services/app/CommerceAdmin/AdjustProductUsage",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfProductSubscriptionDto Success
   * @throws ApiError
   */
  public assignProductPlan({
    requestBody,
  }: {
    requestBody?: AssignCommerceProductPlanInput;
  }): CancelablePromise<AjaxResponseOfProductSubscriptionDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/services/app/CommerceAdmin/AssignProductPlan",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfProductPlanChangeResult Success
   * @throws ApiError
   */
  public changeWorkspaceProductPlan({
    requestBody,
  }: {
    requestBody?: ChangeWorkspaceCommerceProductPlanInput;
  }): CancelablePromise<AjaxResponseOfProductPlanChangeResult> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/services/app/CommerceAdmin/ChangeWorkspaceProductPlan",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfProductPlanDto Success
   * @throws ApiError
   */
  public createOrUpdateProductPlan({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateProductPlanInput;
  }): CancelablePromise<AjaxResponseOfProductPlanDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/services/app/CommerceAdmin/CreateOrUpdateProductPlan",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteProductPlan({ id }: { id?: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/services/app/CommerceAdmin/DeleteProductPlan",
      query: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfProductSubscriptionDto Success
   * @throws ApiError
   */
  public extendTrial({
    requestBody,
  }: {
    requestBody?: ExtendCommerceTrialInput;
  }): CancelablePromise<AjaxResponseOfProductSubscriptionDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/services/app/CommerceAdmin/ExtendTrial",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfPagedResultDtoOfCommerceEnrollmentMonitorDto Success
   * @throws ApiError
   */
  public getEnrollments({
    status,
    productCode,
    skipCount,
    maxResultCount,
  }: {
    status?: string;
    productCode?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfCommerceEnrollmentMonitorDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/services/app/CommerceAdmin/GetEnrollments",
      query: {
        status: status,
        productCode: productCode,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns AjaxResponseOfProductPlanDto Success
   * @throws ApiError
   */
  public getProductPlanForEdit({
    id,
  }: {
    id?: number;
  }): CancelablePromise<AjaxResponseOfProductPlanDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/services/app/CommerceAdmin/GetProductPlanForEdit",
      query: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfProductPlanDto Success
   * @throws ApiError
   */
  public getProductPlans({
    productCode,
    isPublic,
    isActive,
  }: {
    productCode?: string;
    isPublic?: boolean;
    isActive?: boolean;
  }): CancelablePromise<AjaxResponseOfListOfProductPlanDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/services/app/CommerceAdmin/GetProductPlans",
      query: {
        productCode: productCode,
        isPublic: isPublic,
        isActive: isActive,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfCommerceWorkspaceSubscriptionDto Success
   * @throws ApiError
   */
  public getWorkspaceSubscriptions({
    workspaceId,
  }: {
    workspaceId?: number;
  }): CancelablePromise<AjaxResponseOfListOfCommerceWorkspaceSubscriptionDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/services/app/CommerceAdmin/GetWorkspaceSubscriptions",
      query: {
        workspaceId: workspaceId,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public retryEnrollment({
    requestBody,
  }: {
    requestBody?: CommerceEnrollmentInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/services/app/CommerceAdmin/RetryEnrollment",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public setProductPlanActive({
    requestBody,
  }: {
    requestBody?: SetProductPlanActiveInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/services/app/CommerceAdmin/SetProductPlanActive",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfCommerceSynchronizationResultDto Success
   * @throws ApiError
   */
  public synchronizeEntitlements({
    requestBody,
  }: {
    requestBody?: SynchronizeCommerceEntitlementsInput;
  }): CancelablePromise<AjaxResponseOfCommerceSynchronizationResultDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/services/app/CommerceAdmin/SynchronizeEntitlements",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfProductPlanChangePreview Success
   * @throws ApiError
   */
  public previewWorkspaceProductPlan({
    requestBody,
  }: {
    requestBody?: PreviewWorkspaceProductPlanInput;
  }): CancelablePromise<AjaxResponseOfProductPlanChangePreview> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/services/app/CommerceAdmin/PreviewWorkspaceProductPlan",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
  /**
   * @returns AjaxResponseOfListOfCommerceProductDefinitionDto Success
   * @throws ApiError
   */
  public getProductDefinitions(): CancelablePromise<AjaxResponseOfListOfCommerceProductDefinitionDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/services/app/CommerceAdmin/GetProductDefinitions",
    });
  }
}
